/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CourseStatus = "complete" | "failed" | "incomplete" | "%future added value";
export type DelegateProfilePage_delegate = {
    readonly uuid: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly email: string | null;
    readonly jobTitle: string;
    readonly telephone: string | null;
    readonly TTC_ID: string;
    readonly lastLogin: string;
    readonly currentBackgroundCheck: {
        readonly idExpiryDate: string | null;
        readonly dbsExpiryDate: string | null;
    } | null;
    readonly hasActiveBackgroundCheck: boolean;
    readonly backgroundCheckPending: boolean;
    readonly company: {
        readonly name: string;
    };
    readonly hasSimulatorAccess: boolean;
    readonly myCourses: ReadonlyArray<{
        readonly status: CourseStatus;
        readonly expiresAt: string | null;
        readonly enrolledAt: string;
        readonly certificateURL: string | null;
        readonly progress: {
            readonly total: number;
            readonly completed: number;
        } | null;
        readonly partTwo: {
            readonly status: CourseStatus;
            readonly certificateURL: string | null;
            readonly expiresAt: string | null;
        } | null;
        readonly course: {
            readonly name: string;
            readonly category: {
                readonly name: string;
            } | null;
            readonly partTwo?: {
                readonly ident: number;
            } | null;
        } | null;
    }> | null;
    readonly myClassroomCourses: ReadonlyArray<{
        readonly status: CourseStatus;
        readonly expiresAt: string | null;
        readonly enrolledAt: string;
        readonly certificateURL: string | null;
        readonly course: {
            readonly ident: number;
            readonly name: string;
            readonly category: {
                readonly name: string;
            } | null;
        } | null;
    }> | null;
    readonly documents: {
        readonly edges: ReadonlyArray<{
            readonly uuid: string;
            readonly name: string;
            readonly expiryDate: string | null;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"CourseTable_delegate" | "DocumentsTable_delegate" | "ProfileCard_delegate">;
    readonly " $refType": "DelegateProfilePage_delegate";
};
export type DelegateProfilePage_delegate$data = DelegateProfilePage_delegate;
export type DelegateProfilePage_delegate$key = {
    readonly " $data"?: DelegateProfilePage_delegate$data;
    readonly " $fragmentRefs": FragmentRefs<"DelegateProfilePage_delegate">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "uuid",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v2 = [
        (v1 /*: any*/)
    ], v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "status",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "expiresAt",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "enrolledAt",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "certificateURL",
        "args": null,
        "storageKey": null
    } as any), v7 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "category",
        "storageKey": null,
        "args": null,
        "concreteType": "Category",
        "plural": false,
        "selections": (v2 /*: any*/)
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": "ident",
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "DelegateProfilePage_delegate",
        "type": "Delegate",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "firstName",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "lastName",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "email",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "jobTitle",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "telephone",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "TTC_ID",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "lastLogin",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "currentBackgroundCheck",
                "storageKey": null,
                "args": null,
                "concreteType": "BackgroundCheck",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "idExpiryDate",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "dbsExpiryDate",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasActiveBackgroundCheck",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "backgroundCheckPending",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "company",
                "storageKey": null,
                "args": null,
                "concreteType": "Company",
                "plural": false,
                "selections": (v2 /*: any*/)
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasSimulatorAccess",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "myCourses",
                "storageKey": null,
                "args": null,
                "concreteType": "MyCourse",
                "plural": true,
                "selections": [
                    (v3 /*: any*/),
                    (v4 /*: any*/),
                    (v5 /*: any*/),
                    (v6 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "progress",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Progress",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "total",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "completed",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "partTwo",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "MyCourse",
                        "plural": false,
                        "selections": [
                            (v3 /*: any*/),
                            (v6 /*: any*/),
                            (v4 /*: any*/)
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "course",
                        "storageKey": null,
                        "args": null,
                        "concreteType": null,
                        "plural": false,
                        "selections": [
                            (v1 /*: any*/),
                            (v7 /*: any*/),
                            {
                                "kind": "InlineFragment",
                                "type": "OnlineCourse",
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "partTwo",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": null,
                                        "plural": false,
                                        "selections": [
                                            (v8 /*: any*/)
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "myClassroomCourses",
                "storageKey": null,
                "args": null,
                "concreteType": "MyCourse",
                "plural": true,
                "selections": [
                    (v3 /*: any*/),
                    (v4 /*: any*/),
                    (v5 /*: any*/),
                    (v6 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "course",
                        "storageKey": null,
                        "args": null,
                        "concreteType": null,
                        "plural": false,
                        "selections": [
                            (v8 /*: any*/),
                            (v1 /*: any*/),
                            (v7 /*: any*/)
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "documents",
                "storageKey": null,
                "args": null,
                "concreteType": "DocumentPage",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Document",
                        "plural": true,
                        "selections": [
                            (v0 /*: any*/),
                            (v1 /*: any*/),
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "expiryDate",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "CourseTable_delegate",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "DocumentsTable_delegate",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "ProfileCard_delegate",
                "args": null
            }
        ]
    } as any;
})();
(node as any).hash = '16fb56032803fb8aee1edfb2ecb123cf';
export default node;
